import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AuthService} from "../../../services/auth.service";
import {DropdownService} from "../../../services/dropdown.service";
import {IncidentService} from "../../../services/incident.service";
import {MatDialog} from "@angular/material/dialog";
import {NewIncidentFormComponent} from "../../incidents/new-incident-form/new-incident-form.component";
import {
  AssociatedEvidencesResp,
  IncidentRecord,
  ReportModify,
  ReportRecord,
  TriggerAssociatedIncidentsType
} from "../../../NIBINInterface";
import {RptModifyImportIncidentComponent} from "./rpt-modify-import-incident/rpt-modify-import-incident.component";
import {ReportService} from "../../../services/report.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DialogService} from "../../../services/dialog.service";
import Swal from "sweetalert2";
import {formatDate} from "@angular/common";

@Component({
  selector: 'app-report-modify-form',
  templateUrl: './report-modify-form.component.html',
  styleUrls: ['./report-modify-form.component.css']
})
export class ReportModifyFormComponent implements OnInit {
  @ViewChild("dialog") dialogTarget!: ElementRef;

  @Input ('CType') CType: ReportModify = ReportModify.ADD;
  isEdit:boolean = this.CType === ReportModify.EDIT
  @Output('DoneEvent') DoneEvent = new EventEmitter<{ReportInfo:ReportRecord, Incidents:IncidentRecord[]}>()

  @Input ('Incidents') Incidents: IncidentRecord[] = [];
  CaliberWarning:boolean = this.isCaliberMismatchWarning()
  @Input('ReportInfo') ReportInfo: ReportRecord = {
    Assoc_VGID_Number: null,
    Assoc_VGID_State: null,
    Assoc_VGID_Status: null,
    EmailSent: null,
    EnteredDateTime: null, //formatDate(new Date(), 'yyyy-MM-dd','en-US'),
    Examiner: null,
    ID: null,
    Incidents: null,
    Lab: null,
    NIBINHit: null,
    NOTE: null,
    NumOfEmailSent: null,
    ReferenceNumber: null,
    ReportID: null,
    ReportStatus: null,
    ReportType: null,
    Reviewer: null,
    UpdateNo: null,
    UpdatedDateTime: null,
    UserID: null,
    showAllWeaponsFlag: false,
  };

  OriginalIncidents: IncidentRecord[] = [];
  OriginalReportInfo: ReportRecord = {
    Assoc_VGID_Number: null,
    Assoc_VGID_State: null,
    Assoc_VGID_Status: null,
    EmailSent: null,
    EnteredDateTime: null,
    Examiner: null,
    ID: null,
    Incidents: null,
    Lab: null,
    NIBINHit: null,
    NOTE: null,
    NumOfEmailSent: null,
    ReferenceNumber: null,
    ReportID: null,
    ReportStatus: null,
    ReportType: null,
    Reviewer: null,
    UpdateNo: null,
    UpdatedDateTime: null,
    UserID: null,
    showAllWeaponsFlag: null,
  };

  RemovedIncidents:string[] = []
  constructor(private authService: AuthService,private dropdownService: DropdownService,private incidentService: IncidentService,private reportService: ReportService, public dialog: MatDialog, private dialogService: DialogService, private matSnackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.OriginalIncidents={...this.Incidents}
    this.OriginalReportInfo={...this.ReportInfo}
    this.isEdit = (this.CType === ReportModify.EDIT)
  }

  ngOnDestroy() {
    //save pending to local storage?
  }


  showExistingIncidentSearchDialog(){
    let existingIncidentRef = this.dialog.open(RptModifyImportIncidentComponent, {
      width: '80%',
      height: '80%',
      data: {}
    })

    existingIncidentRef.componentInstance.IncidentSelected.subscribe((val)=>{
      if(this.Incidents.indexOf(val) == -1){
        this.Incidents.push(val)
        Swal.fire({
          icon: 'success',
          title: 'System Notification',
          text: 'Incident has been Imported into Report',
          timerProgressBar:true,
          timer:5000
        })

      }


      if(this.Incidents) {
        this.Incidents.sort(this.reportService.sortReportsIncidents)
        for(let i of this.Incidents){
          i.RPT_AdditionalInfoEvidence = this.reportService.makeIncidentEvidenceLines(i)
        }
      }

    })
  }

  showNewIncidentDialog(){
    let dia = this.dialog.open(NewIncidentFormComponent, {
      width: '80%',
      height: '80%',
      disableClose:true
    })

    dia.backdropClick().subscribe(_ => {
      Swal.fire({
        title: 'Are you sure you want to Close? Any Changes will be lost.',
        showDenyButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor:'darkblue',
        denyButtonText: `No`,
        denyButtonColor:'darkblue',
        timer: 10000,
        timerProgressBar: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          dia.close();
        }
      })
    })

    dia.componentInstance.IncidentCreated.subscribe((val)=>{
      this.incidentService.saveIncToDB(val).then((r)=>{

        if(r?.MessageCode === 200){
          this.Incidents.push(r.AnyData);
          if(this.Incidents) {
            this.Incidents.sort(this.reportService.sortReportsIncidents)
            for(let i of this.Incidents){
              i.RPT_AdditionalInfoEvidence = this.reportService.makeIncidentEvidenceLines(i)
            }
          }

          Swal.fire({
            icon: 'success',
            title: 'System Notification',
            text: "Successfully Created Incident Record",
            timerProgressBar:true,
            timer:4000
          })
          dia.close();
        }
        else if(r?.MessageCode === 600) {
          Swal.fire({
            icon: 'error',
            title: 'System Notification',
            text: "Duplicate Incident Found (Based off Lab, Case #, and Lab #) ",
            timerProgressBar:true,
            timer:5000
          })
        }
      });
    })
  }

  RemoveSelectedForReport(incident:IncidentRecord) {
    if(incident.IncidentID)
      this.RemovedIncidents.push(incident.IncidentID)
    this.Incidents.splice(this.Incidents.indexOf(incident),1)
    this.Incidents.sort(this.reportService.sortReportsIncidents)
  }

  isCaliberMismatchWarning():boolean{
    let flag:boolean=false
    if(this.Incidents){
      for(let i of this.Incidents){
        if(i.Ballistics){
          for(let i2 of this.Incidents){
            if(i2.Ballistics){
              for(let b1 of i.Ballistics){
                for(let b2 of i2.Ballistics){
                  if((b1.Caliber_Type != b2.Caliber_Type) && b1.VGID_CPart==="Cartridge Case" && b2.VGID_CPart==="Cartridge Case" && b1.SelectedForAssoc && b2.SelectedForAssoc)
                    flag=true
                }
              }
            }
          }
        }
        if(i.Weapon){
          for(let i2 of this.Incidents){
            if(i2.Ballistics){
              for(let b1 of i.Weapon){
                for(let b2 of i2.Ballistics){
                  if((b1.CALIBER != b2.Caliber_Type) && b2.VGID_CPart==="Cartridge Case" && b1.SelectedForAssoc && b2.SelectedForAssoc)
                    flag=true
                }
              }
            }
          }
        }
      }
    }
    return flag
  }

  datesAreOnSameDay = (first:Date, second:Date) => first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();

  async RunCheckBeforeSaveReport(){
    this.reportService.updateEvidenceMasters(this.Incidents)

    let flag:boolean = false;
    for(let i of this.Incidents){
      if(i.OccurrenceDate && this.ReportInfo.EnteredDateTime){
        if(this.datesAreOnSameDay(new Date(i.OccurrenceDate),new Date(this.ReportInfo.EnteredDateTime))){

        } else if(new Date(i.OccurrenceDate) > new Date(this.ReportInfo.EnteredDateTime))
          flag=true;
      }
    }
    if(flag){
      Swal.fire({
        icon:'error',
        title: "Report date cannot be before Incident(s) Occurrence date",
        timer: 20000,
        timerProgressBar: true,
      })
      return;

    }

    if(this.isCaliberMismatchWarning()){
      Swal.fire({
        icon:'warning',
        title: "A Evidence Caliber Mismatch has been Detected. If you are sure that that the report is correct, you can disregard this warning.",
        showDenyButton: true,
        confirmButtonText: 'Proceed with Saving Report',
        confirmButtonColor:'darkblue',
        denyButtonText: `Go Back`,
        denyButtonColor:'darkblue',
        timer: 20000,
        timerProgressBar: true,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed){
          this.saveReport()
        }
      })
    }
    else{
      this.saveReport()
    }
  }

  async saveReport() {

    this.ReportInfo.Lab = this.authService.getUser().CurrentDept;
    this.ReportInfo.UserID = this.authService.getUser().empID;
    let r = this.ReportInfo

    //Always force a PENDING Status when saving a complete report
    r.ReportStatus = 'PENDING'

    if(this.CType == ReportModify.ADD){
       r = await this.reportService.saveRptToDB(this.ReportInfo)
    }
    else if(this.CType == ReportModify.EDIT){
      r = await this.reportService.updateReportDB(this.ReportInfo)
      for(let id of this.RemovedIncidents){
        this.reportService.removeLinkIncToReport({ReportID:(r.ReportID? r.ReportID:''), IncidentID:id, SelectedAsPrimary:false })
      }

    }

    if(r.ReportID){
      for (let i of this.Incidents) {
        if (i.IncidentID)
          this.reportService.linkIncToReport({ReportID:r.ReportID, IncidentID:i.IncidentID, SelectedAsPrimary:!!i?.SelectedAsPrimary})
      }



      for (let i of this.Incidents) {
        if (i.IncidentID){
          if(i.Weapon){
            for (let w of i.Weapon) {

              if(w.SelectedForAssoc && w.ID)
                this.reportService.addAssociation({EvidenceID: w.ID, EvidenceType: "WEAPON", IncidentID: i.IncidentID, ReportID: r.ReportID, Assoc_Type:w.Assoc_Type})
              else if(!w.SelectedForAssoc && w.ID)
                this.reportService.removeAssociation({EvidenceID: w.ID, EvidenceType: "WEAPON", IncidentID: i.IncidentID, ReportID: r.ReportID, Assoc_Type:w.Assoc_Type})
            }
          }
          if(i.Ballistics){
            for (let b of i.Ballistics) {
              if(b.SelectedForAssoc && b.ID)
                this.reportService.addAssociation({EvidenceID: b.ID, EvidenceType: "BALLISTIC", IncidentID: i.IncidentID, ReportID: r.ReportID, Assoc_Type:b.Assoc_Type})
              else if(!b.SelectedForAssoc && b.ID)
                this.reportService.removeAssociation({EvidenceID: b.ID, EvidenceType: "BALLISTIC", IncidentID: i.IncidentID, ReportID: r.ReportID, Assoc_Type:b.Assoc_Type})
            }
          }
        }
      }

      //this.reportService.updateReportStatus({ReportID: r.ReportID, Status: 'PENDING'})

      this.DoneEvent.emit({Incidents: this.Incidents, ReportInfo: this.ReportInfo})
      Swal.fire({
        icon: 'success',
        title: 'System Notification',
        text: "Report Successfully Saved",
        timerProgressBar:true,
        timer:4000
      })

    }

    this.resetForm()
  }

  resetForm():void{
    this.Incidents = []
    this.ReportInfo = <ReportRecord>{
      Assoc_VGID_Number: null,
      Assoc_VGID_State: null,
      Assoc_VGID_Status: null,
      EmailSent: null,
      EnteredDateTime: null,
      Examiner: null,
      ID: null,
      Incidents: null,
      Lab: null,
      NIBINHit: null,
      NOTE: null,
      NumOfEmailSent: null,
      ReferenceNumber: null,
      ReportID: null,
      ReportStatus: null,
      ReportType: null,
      Reviewer: null,
      UpdateNo: null,
      UpdatedDateTime: null,
      UserID: null
    }
  }

  validateReport():boolean {
    if(!this.ReportInfo.EnteredDateTime && this.ReportInfo.EnteredDateTime!='')
      return false
    if(!this.ReportInfo.Examiner && this.ReportInfo.Examiner!='')
      return false
    if(!this.ReportInfo.Reviewer && this.ReportInfo.Reviewer!='')
      return false
    if(this.Incidents.length<1)
      return false

    return true;
  }

  cancelEdit() {
    //this.Incidents = this.OriginalIncidents
    //this.ReportInfo = this.OriginalReportInfo
    this.DoneEvent.emit({Incidents: [], ReportInfo: <ReportRecord>{}})
  }


  CanShowPrompt(r: AssociatedEvidencesResp):boolean {
    let flag = false;
    if(r.Incidents){
      for(let i of r.Incidents){
        if (!(this.Incidents.some(e => e.IncidentID === i.IncidentID))) {
          flag=true
        }
      }
    }
    return flag;
  }



  async HandleAssociatedIncidentsTrigger(e: TriggerAssociatedIncidentsType) {
    if(e.ID){
      let r = await this.reportService.getAssociatedEvidences(e.ID.toString(), e.EType)

      if(this.CanShowPrompt(r)){
        if(r.Incidents && r.Incidents.length>0){
          Swal.fire({
            title: "We have Detected that This Evidence Item is apart of a Evidence Chain. Would you like to import the chain?",
            showDenyButton: true,
            confirmButtonText: 'Yes',
            confirmButtonColor:'darkblue',
            denyButtonText: `No`,
            denyButtonColor:'darkblue',
            timer: 20000,
            timerProgressBar: true,
            reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {
              //Update the Evidence Masters
              this.reportService.updateEvidenceMasters(this.Incidents)

              if(r.Incidents && r.Incidents.length>0){
                for(let i of r.Incidents){
                  //Make sure that this incident is not already in the report
                  if (!(this.Incidents.some(e => e.IncidentID === i.IncidentID))) {
                    this.Incidents.push(i)
                  }
                }

                for(let i of this.Incidents){
                  //Loop through Associated Evidence and mark them as associated
                  if(r.AssociatedWeapon){
                    if(i.Weapon){
                      for(let iw of i.Weapon){
                        if (r.AssociatedWeapon.some(e => e.ID == iw.ID))
                          iw.SelectedForAssoc=true
                      }
                    }
                  }
                  if(r.AssociatedBallistic){
                    if(i.Ballistics){
                      for(let ib of i.Ballistics){
                        if (r.AssociatedBallistic.some(e => e.ID == ib.ID))
                          ib.SelectedForAssoc=true
                      }
                    }
                  }

                  //Now Rebuild The Evidence Lines
                  i.RPT_AdditionalInfoEvidence = this.reportService.makeIncidentEvidenceLines(i)
                  this.Incidents.sort(this.reportService.sortReportsIncidents)
                }
              }
            }
          })

        }
      }

    }
  }
}
